import { Component, EventEmitter, OnInit, Output,OnDestroy ,ElementRef,ViewChild} from '@angular/core';
import { GastroFormsService } from 'src/app/gastro-forms.service';
import { LoginService } from 'src/app/login.service';
import { AutotextService } from 'src/app/autotext.service';
import { Subscription,fromEvent,Subject, } from 'rxjs';
import {  tap, switchMap, takeUntil, finalize} from 'rxjs/operators';

@Component({
    selector: 'app-timeout',
    templateUrl: './timeout.component.html',
    styleUrls: ['./timeout.component.scss'],
    standalone: false
})
export class TimeoutComponent implements OnInit {
  @Output() closed = new EventEmitter<string>();
  @Output() print = new EventEmitter<string>();
  @ViewChild('canvasDocSign', {static: true}) canvasDocSign: ElementRef<HTMLCanvasElement>; 
  @ViewChild("canvasSign", { static: true })
  canvasSign: ElementRef<HTMLCanvasElement>;
  changeCanvas$ = new Subject();
  changeDocCanvas$ = new Subject();
  destroy$ = new Subject();
  formSub = new Subscription();
  nurseSignSub = new Subscription();
  doctroSignSub = new Subscription();
  ctx: CanvasRenderingContext2D;
  sensitivitiesDropdownList: string[] = ['ביצים','סויה','תרופות'];
  responsibleList=[]
  extraSensitivities=""
  responsible=""
  currentDate: Date = new Date();
  currentTime: Date = new Date();

   
  
 



  constructor(public gfs:GastroFormsService, public ls:LoginService,public atS:AutotextService) {
    this.responsibleList.push(ls.username)
   }

  ngOnInit() {
    this.formSub = this.gfs.formLoaded$.subscribe((data) => {
      if (this.gfs.Form && this.gfs.Form.get("nurseSign").value) {
        this.loadSign();
      }
      if (this.gfs.Form && this.gfs.Form.get("doctorSign").value) {
        this.loadDocSign();
      }
      // Get the current value of medSens form control
      const medSensValue = this.gfs.Form.get("medSens").value;
      const ResponsibleForm = this.gfs.Form.get("ResponsibleForm").value;

      // Iterate through medSensValue to check for values not in sensitivitiesDropdownList
      if (Array.isArray(medSensValue)) {
        medSensValue.forEach((value: string) => {
          if (!this.sensitivitiesDropdownList.includes(value)) {
            // If the value is not in the array, push it
            this.sensitivitiesDropdownList.push(value);
          }
        });
      }
      if (Array.isArray(ResponsibleForm)) {
        ResponsibleForm.forEach((value: string) => {
          if (!this.responsibleList.includes(value)) {
            // If the value is not in the array, push it
            this.responsibleList.push(value);
          }
        });
      }
    });
    console.log(this.gfs.Form,'time out form')
  }
  printForm(){
    this.print.emit('1')
  }
  close(toclose: boolean) {
    this.closed.emit(toclose ? '1': null);
  }

  ngAfterViewInit(){
    this.nurseSignSub = this.changeCanvas$
      .pipe(takeUntil(this.destroy$))
      .subscribe((data: any) => {
        this.ctx = data.ctx;
        const mouseDownStream = fromEvent(
          this.canvasSign.nativeElement,
          "mousedown"
        );
        const mouseMoveStream = fromEvent(
          this.canvasSign.nativeElement,
          "mousemove"
        );
        const mouseUpStream = fromEvent(window, "mouseup");
        mouseDownStream
          .pipe(
            tap((event: MouseEvent) => {
              this.ctx.beginPath();
              this.ctx.strokeStyle = "black";
              this.ctx.lineWidth = 5;
              this.ctx.lineJoin = "round";
              this.ctx.moveTo(event.offsetX, event.offsetY);
            }),
            switchMap(() =>
              mouseMoveStream.pipe(
                tap((event: MouseEvent) => {
                  this.ctx.lineTo(event.offsetX, event.offsetY);
                  this.ctx.stroke();
                }),
                takeUntil(mouseUpStream),
                finalize(() => {
                  // this.ctx.closePath();
                  this.saveSign();
                })
              )
            )
          )
          .subscribe((data) => {
            // console.log(data);
          });
      });
    this.doctroSignSub = this.changeDocCanvas$
      .pipe(takeUntil(this.destroy$))
      .subscribe((data: any) => {
        this.ctx = data.ctx;
        const mouseDownStream = fromEvent(
          this.canvasDocSign.nativeElement,
          "mousedown"
        );
        const mouseMoveStream = fromEvent(
          this.canvasDocSign.nativeElement,
          "mousemove"
        );
        const mouseUpStream = fromEvent(window, "mouseup");
        mouseDownStream
          .pipe(
            tap((event: MouseEvent) => {
              this.ctx.beginPath();
              this.ctx.strokeStyle = "black";
              this.ctx.lineWidth = 5;
              this.ctx.lineJoin = "round";
              this.ctx.moveTo(event.offsetX, event.offsetY);
            }),
            switchMap(() =>
              mouseMoveStream.pipe(
                tap((event: MouseEvent) => {
                  this.ctx.lineTo(event.offsetX, event.offsetY);
                  this.ctx.stroke();
                }),
                takeUntil(mouseUpStream),
                finalize(() => {
                  // this.ctx.closePath();
                  this.saveDocSign();
                })
              )
            )
          )
          .subscribe((data) => {
            // console.log(data);
          });
      });
  }
  // Function to add the sensitivity
  addSensitivity() {
   

    // Check if the value is not empty
    if (this.extraSensitivities && this.extraSensitivities.trim() !== '') {
      // Add the value to the dropdown list
      this.sensitivitiesDropdownList.push(this.extraSensitivities);

      // Add the value to the medSens array
      const currentValue=this.gfs.Form.get('medSens').value
      this.gfs.Form.get('medSens').setValue([...currentValue,this.extraSensitivities])
      // Clear the input field after adding
      this.extraSensitivities=""
      
    }
  }

  addResponsible() {
   

    // Check if the value is not empty
    if (this.responsible && this.responsible.trim() !== '') {
      // Add the value to the dropdown list
      this.responsibleList.push(this.responsible);

      // Add the value to the ResponsibleForm array
      const currentValue=this.gfs.Form.get('ResponsibleForm').value
      this.gfs.Form.get('ResponsibleForm').setValue([...currentValue,this.responsible])
      // Clear the input field after adding
      this.responsible=""
      
    }
  }

  ngOnDestroy(): void {
    // console.log(JSON.stringify(this.gfs.Form),'time out form end')
    if (this.formSub) {
      this.formSub.unsubscribe();
    }

    if (this.nurseSignSub) {
      this.nurseSignSub.unsubscribe();
    }

    if (this.doctroSignSub) {
      this.doctroSignSub.unsubscribe();
    }
  }

clearSign() {
  var ctx = this.canvasSign.nativeElement.getContext("2d");
  ctx.clearRect(
    0,
    0,
    this.canvasSign.nativeElement.width,
    this.canvasSign.nativeElement.height
  );
  this.gfs.Form.get('nurseSign').setValue('');


}

clearDocSign() {
  var ctx = this.canvasDocSign.nativeElement.getContext("2d");
  ctx.clearRect(
    0,
    0,
    this.canvasDocSign.nativeElement.width,
    this.canvasDocSign.nativeElement.height
  );
  this.gfs.Form.get('doctorSign').setValue('');


}

setCanvas() {
  this.ctx = this.canvasSign.nativeElement.getContext("2d");
  this.changeCanvas$.next({ canvas: this.canvasSign, ctx: this.ctx });
}

setDocCanvas() {
  this.ctx = this.canvasDocSign.nativeElement.getContext("2d");
  this.changeDocCanvas$.next({ canvas: this.canvasDocSign, ctx: this.ctx });
}

saveSign() {
  let canvasUrl = this.canvasSign.nativeElement.toDataURL("image/png");
      this.gfs.Form.get("nurseSign").setValue(canvasUrl);
     
  }

saveDocSign() {
  let canvasUrl = this.canvasDocSign.nativeElement.toDataURL("image/png");
      this.gfs.Form.get("doctorSign").setValue(canvasUrl);
     
  }

  loadSign(){
    var ctx = this.canvasSign.nativeElement.getContext("2d");
      const imgNurseSign = document.createElement("img");
      imgNurseSign.onload = function () {
        ctx.drawImage(imgNurseSign, 0, 0); // Or at whatever offset you like
      };
      imgNurseSign.src = this.gfs.Form.get("nurseSign").value;
  }

  loadDocSign(){
    var ctx = this.canvasDocSign.nativeElement.getContext("2d");
      const imgDocSign = document.createElement("img");
      imgDocSign.onload = function () {
        ctx.drawImage(imgDocSign, 0, 0); // Or at whatever offset you like
      };
      imgDocSign.src = this.gfs.Form.get("doctorSign").value;
  }


  




}
